import { is } from "date-fns/locale";
import { getLimiteOperacaoByMoeda } from "../modules/cliente/moedasService";
import { getCupom } from "../modules/cliente/clienteService";

const { default: Dexie } = require("dexie");

class LocalDBDexie extends Dexie {
  constructor() {
    super("developDB");
    this.version(3).stores({
      carrinho:
        "++id, tipo, nome, quantidade , valor, toleranciaMin, toleranciaMax, liberado, liberadoBR, embalagemProtetora, cupom",
    });

    this.open();
    this.carrinho = this.table("carrinho");
  }

  async getById(id) {
    try {
      const item = await this.carrinho.get(id);
      return item;
    } catch (error) {
      console.error("Erro ao buscar item por ID:", error);
      return null;
    }
  }
  async setCarrinho(item) {
    try {
      await this.transaction("rw", this.carrinho, async () => {
        const itemExistente = await this.carrinho
          .where({ nome: item.nome })
          .first();

        if (itemExistente) {
          await this.carrinho.where({ nome: item.nome }).modify((valor) => {
            valor.quantidade += item.quantidade;
          });
        } else {
          await this.carrinho.add(item);
        }
      });
    } catch (error) {
      console.log("Erro ao salvar carrinho localmente: ", error);
    }
  }

  async setEmbalagem(id, boolean) {
    try {
      await this.transaction("rw", this.carrinho, async () => {
        await this.carrinho.where({ id: id }).modify((item) => {
          item.embalagemProtetora = boolean;
        });
      });
    } catch (error) {
      console.log("Erro ao atualizar embalagem: ", error);
    }
  }

  async setCupom(item, cupom = null) {
    try {
      console.log(cupom)
      await this.transaction("rw", this.carrinho, async () => {
        let cupomObj = {
          valido: false,
        };
        if (cupom) {
          cupomObj = {
            valido: true,
            ...cupom,
          };

          const itemExistente = await this.carrinho
            .where({ nome: item.nome })
            .first();

          if (itemExistente) {
            await this.carrinho.where({ nome: item.nome }).modify((valor) => {
              valor.cupom = cupomObj;
            });
          }
        } else {
          console.log("Cupom inválido, prosseguir sem desconto.");
        }
      });
    } catch (error) {
      console.log("Erro ao salvar carrinho localmente: ", error);
    }
  }

  async setItem(item, id) {
    try {
      await this.transaction("rw", this.carrinho, async () => {
        const itemExistente = await this.carrinho.where({ id: id }).first();

        if (itemExistente) {
          await this.carrinho.where({ id: id }).modify((valor) => {
            valor = item;
          });
        } else await this.carrinho.add(item);
      });
    } catch (error) {
      console.log("Erro ao salvar carrinho localmente: ", error);
    }
  }

  async deleteItemCarrinho(id) {
    try {
      await this.transaction("rw", this.carrinho, async () => {
        await this.carrinho.delete(String(id));
      });
    } catch (error) {
      console.log("Erro ao salvar carrinho localmente: ", error);
    }
  }

  async cleanCarrinho() {
    try {
      await this.transaction("rw", this.carrinho, async () => {
        await this.carrinho.clear();
      });
    } catch (error) {
      console.log("Erro ao limpar carrinho localmente: ", error);
    }
  }

  async getCarrinho(validaMoeda = true) {
    const data = await db.carrinho.toArray();

    if (!(data.length > 0)) return [];

    for (const element of data) {
      if (validaMoeda && element?.codIso) {
        try {
          let codIso = element.codIso === "EUSCOM" ? "USD" : element.codIso;
          const moedaData = await getLimiteOperacaoByMoeda(codIso);
          element.toleranciaMin = moedaData.toleranciaMin;
          element.toleranciaMax = moedaData.toleranciaMax;
          element.liberado = moedaData.liberado;
          element.liberadoBR = moedaData.liberadoBR;
        } catch (error) {
          console.log("Moeda Não encontrada!");
        }
      }
    }

    return data;
  }

  async validarCupom(codigo) {
    let cupom = null;
    await getCupom(codigo)
      .then((res) => {
        const data = res.data;
        cupom = {
          desconto: data.valor_desconto,
          descricao: data.descricao,
          condicao:
            "Válido nas compras acima de R$6.000,00 na Central de Vendas.",
          valor: data.valor_minimo_compra,
          observacao:
            "Válido para qualquer tipo de dólar (USD, CAD, AUD, etc.).",
          moedasPermitidas: data.listaMoedas.map((moeda) => moeda.codMoeda),
        };
      })
      .catch((error) => {
        console.log("Erro ao validar cupom: ", error);
        cupom = null;
      });
    return cupom;
  }
}

async function verificarCupomDesconto(cupom) {
  const cuponsValidos = {
    OMD10: {
      desconto: 10,
      descricao: "Cupom de R$ 10,00 na compra de dólar em espécie.",
      condicao: "Válido nas compras acima de R$6.000,00 na Central de Vendas.",
      valor: 6000,
      observacao: "Válido para qualquer tipo de dólar (USD, CAD, AUD, etc.).",
      moedasPermitidas: [
        "Dólar Americano",
        "Dólar Canadense",
        "Dólar Australiano",
        "Dólar Neozelandês",
      ],
    },
    OMCPP: {
      desconto: 10,
      descricao: "Cupom de R$ 10,00 na compra e recarga de Cartão Pré-Pago.",
      condicao:
        "Válido para compras acima de R$ 2.000,00 na Central de Vendas.",
      valor: 2000,
      observacao: "",
      moedasPermitidas: [],
    },
    OMAL44: {
      desconto: 44,
      descricao:
        "Cupom de R$ 44,00 na compra de moedas em espécie da América Latina.",
      condicao:
        "Válido para compras acima de R$ 2.000,00 na Central de Vendas.",
      valor: 2000,
      observacao: [
        "Peso Chileno, Argentino, Uruguaio, Novo Sol Peruano, etc.",
        "De acordo com disponibilidade da região.",
      ],
      moedasPermitidas: [
        "Peso Chileno",
        "Peso Argentino",
        "Peso Uruguaio",
        "Sol Peruano",
        "Boliviano",
        "Peso Colombiano",
        "Peso Mexicano",
      ],
    },
    OME10: {
      desconto: 10,
      descricao: "Cupom de R$ 10,00 na compra de euro em espécie.",
      condicao:
        "Válido para compras acima de R$ 6.000,00 na Central de Vendas.",
      valor: 6000,
      observacao: "Válido apenas para euro (EUR).",
      moedasPermitidas: ["Euro"],
    },
    OMRI33: {
      desconto: 33,
      descricao: "Cupom de R$ 33,00 na primeira Remessa Internacional.",
      condicao: "Cupom progressivo acima de R$ 5.500,00 na Central de Vendas.",
      valorMinimo: 5500,
      observacao: "",
      moedasPermitidas: [],
    },
    OMMG15: {
      desconto: 15,
      descricao:
        "Cupom de R$ 15,00 para MoneyGram (Transferência Internacional).",
      condicao:
        "Válido para compras acima de R$ 1.400,00 na Central de Vendas.",
      valorMinimo: 1400,
      observacao: "",
      moedasPermitidas: [],
    },
  };

  return cuponsValidos[cupom] || null;
}

export async function updatedCarrinhoQuantidade(id, novaQuantidade) {
  try {
    await db.carrinho.where({ id: String(id) }).modify((item) => {
      item.quantidade = novaQuantidade;
    });
  } catch (error) {
    console.log("Erro ao atualizar a quantidade do carrinho: ", error);
  }
}

export const db = new LocalDBDexie();
